import PartnerInformation from '../../components/partner-information/partner-information.vue';
import Account from '../../services/account';
import GoogleMaps from 'google-maps';
import AddressService from '../../services/address';
import partnerInformationModal from "../../components/partner-information/partner-information-modal.vue";
import partnerInformationModalMobile from '../../components/partner-information/partner-information-modal-mobile.vue';

export default {
  components:{
    PartnerInformation,
    partnerInformationModal,
    partnerInformationModalMobile
  },
  data() {
    return {
      openMenu: false,
      showInputCep: false,
      showInputCity: false,
      showGetCurrentLocalization: false,
      showMsgEror: false,
      showMsgErorFilter: false,
      showHorarios: false,
      msgError: '',
      cep: '',
      isMobile: false,
      city: '',
      range: 50,
      moveMaisIdParceiroSelecionado: undefined,
      maxRange: 150,
      partners: [],
      showHorariosMobile: false,
      partnersFiltered: [],
      userPosition: {
        latitude: '',
        longitude: '',
      },
      loading: false,
      faqs: [
        {
          ask: 'O que preciso apresentar para retirar o meu TAG?',
          reply: 'Basta levar consigo um documento de identificação com foto (RG. CNH, CTPS ou Passaporte), documento do veículo (original, digital ou foto do documento); e o(s) voucher(s) impresso(s) ou gerado(s) digitalmente.'
        },
        {
          ask: 'Posso pedir para outra pessoa retirar meu TAG?',
          reply: 'Sim, você pode! Basta pedir à pessoa que leve um documento dela de identificação com foto, documento do veículo (original, digital ou foto do documento) e o(s) voucher(s) impresso(s) ou gerado(s) digitalmente.'
        },
        {
          ask: 'Aonde posso pegar o meu TAG Move Mais?',
          reply: 'Você pode retirar seu TAG em qualquer estabelecimento parceiro, basta ir ao de sua preferência com o(s) voucher(s) e documentos necessários.'
        },
        {
          ask: 'Posso comprar o meu TAG no ponto de retirada?',
          reply: 'Não! Nos pontos de retirada só é feito a entrega dos TAGs ao cliente, sendo necessária a apresentação do voucher de retirada, que é gerado somente após a realização da compra pelo nosso site. O processo de compra fica sob responsabilidade do usuário, responsabilizando o estabelecimento parceiro somente do ato de entrega do TAG.'
        },
      ]
    }
  },
  mounted() {

    window.addEventListener('scroll', () => window.scrollY > 0 ? this.isScrolling = true : this.isScrolling = false );

    // saber se está em desktop ou mobile.
    if(window.innerWidth <= 769) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    let el = $(this.$el);
    el.find('.question-box h4').click(function(){
      el.find('.open').removeClass('open');
      $(this).find('i').addClass('open');
      $(this).parent().find('.answer-box').addClass('open');
    });

    GoogleMaps.KEY = 'AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE';
    GoogleMaps.LIBRARIES = ['places'];

    GoogleMaps.load(google => {
      const city = document.getElementById('city');
      const cep = document.getElementById('cep');

      const optionsCep = {
        componentRestrictions: { country: ['BR'] },
        types: ['(regions)'],
        strictBounds: true,
      }

      const optionsCity = { ...optionsCep, types: ['(cities)'] };

      const autocompleteCity = new google.maps.places.Autocomplete(city, optionsCity);
      const autocompleteCep = new google.maps.places.Autocomplete(cep, optionsCep);

      google.maps.event.addListener(autocompleteCity, 'place_changed', () => {
        if(autocompleteCity.getPlace().formatted_address) {
          this.city = autocompleteCity.getPlace().formatted_address;
        }
        this.searchByCity();
      });

      google.maps.event.addListener(autocompleteCep, 'place_changed', () => {
        if(autocompleteCep.getPlace().name.length == 9) {
          this.cep = autocompleteCep.getPlace().name;
          this.searchByCep();
        }
      });
    });
  },

  watch: {
    range() {
      if(this.partners.length > 0) {
        this.partnersFiltered = this.partners.filter(p => p.distancia <= this.range);

        if(this.partnersFiltered.length == 0) {
          this.msgError = 'Nenhum ponto de retirada encontrado nesta distância. Tente aumentar a distância da busca.';
          this.showMsgErorFilter = true;
          return;
        }
        this.showMsgErorFilter = false;
        return;
      }
    }
  },
  methods: {
    showInputCepFunc() {
      if(this.showInputCep) {
        this.showInputCep = false;
      } else {
        this.showInputCep = true;
        setTimeout(() => document.getElementById('cep').focus(), 1);
      }
      this.showInputCity = false;
      this.showGetCurrentLocalization = false;
      this.showMsgEror = false;
      this.showMsgErorFilter = false;
      this.partnersFiltered = [];
    },

    showInputCityFunc() {
      if(this.showInputCity) {
        this.showInputCity = false;
      } else {
        this.showInputCity = true;
        setTimeout(() => document.getElementById('city').focus(), 1);
      }
      this.showInputCep = false;
      this.showGetCurrentLocalization = false;
      this.showMsgEror = false;
      this.showMsgErorFilter = false;
      this.partnersFiltered = [];
    },

    showGetCurrentLocalizationFunc() {
      this.showGetCurrentLocalization = true;
      this.showInputCep = false;
      this.showInputCity = false;
      this.showMsgEror = false;
      this.showMsgErorFilter = false;
      this.partnersFiltered = [];
    },

    preencheMoveMaisId (moveMaisId){
      this.moveMaisIdParceiroSelecionado = moveMaisId;
    },
    showModalHorarios(value){
      if(value === 1 && !this.isMobile){
        this.showHorarios = true;
        this.showHorariosMobile = false;
      }else if(value === 1 && this.isMobile){
        this.showHorariosMobile = true;
        this.showHorarios = false;
      }
      else{
        this.showHorarios = false;
        this.showHorariosMobile = false;
      }
    },

    fecharModalHorarios(value){
      if(value == 1){
          this.showHorarios = false;
          this.showHorariosMobile = false;
      }else{
        this.showHorarios = true;

      }
    },

    hideMsgError() {
      this.showMsgEror = false;
      this.msgError = '';
    },

    async searchByCep() {

      this.hideMsgError();
      this.partnersFiltered = [];
      this.loading = true;

      try {
        const { latitude, longitude } = await this.getLatLngGoogle(this.cep.replaceAll('-', ''));
        this.userPosition = { latitude, longitude };
        await this.getPartnersByPosition(this.userPosition );

        if(this.partners.length == 0) throw new Error(1);

      } catch (e) {
        if(e.message == 1) {
          if(this.range < 150) {
            this.msgError = 'Nenhum ponto de retirada próximo encontrado. Tente aumentar a distância de busca para encontrar o ponto de retirada mais próximo de seu CEP.';
          } else {
            this.msgError = 'Nenhum ponto de retirada próximo encontrado pelo Cep informado.';
          }
        } else {

          this.msgError = 'CEP não encontrado. Por favor verifique se o número está correto ou use outra forma para encontrar o ponto de retirada mais próximo.';
        }
        this.showMsgEror = true;
        return;
      } finally {
        this.loading = false;
      }
    },

    async searchByCity() {
      this.hideMsgError();
      this.partnersFiltered = [];
      this.loading = true;

      try {

        const { latitude, longitude } = await this.getLatLngGoogle(this.city);
        this.userPosition = { latitude, longitude };
        await this.getPartnersByPosition({ latitude, longitude, range: this.range });
        if(this.partners.length == 0) throw new Error();
      } catch (e) {

        this.msgError = 'Cidade não encontrada. Por favor verifique se o nome está correto ou use outra forma para encontrar o ponto de retirada mais próximo.';
        this.showMsgEror = true;
        return;
        // if(e.message == 1) {
        //   if(this.address.state.length > 2) {
        //     this.msgError = `Nenhum ponto de retirada próximo a ${this.address.city.split('-')[0].trim()}.`;
        //   } else {
        //     this.msgError = `Nenhum ponto de retirada próximo a ${this.address.city.split('-')[0].trim()} - ${this.address.state}.`;
        //   }
        //   this.showMsgEror = true;
        //   return;
        // } else if(e.code == 1) {
        //   this.msgError = 'Não foi possível encontrar sua localização atual. Por favor verifique se sua localização está ativada, ou tente buscar por CEP para encontrar o ponto de retirada mais próximo.';
        //   this.showMsgEror = true;
        //   return;
        // } else {
        //
        //   this.msgError = 'Cidade não encontrada. Por favor verifique se o nome está correto ou use sua localização para encontrar o ponto de retirada mais próximo.';
        //   this.showMsgEror = true;
        //   return;
        // }
      } finally {
        this.loading = false;
      }
    },

    async searchByCurrentLocalization() {
      this.hideMsgError();
      this.partnersFiltered = [];
      this.loading = true;

      this.showGetCurrentLocalizationFunc();

      try {
        this.userPosition = await this.getCurrentLocalization();
        await this.getPartnersByPosition(this.userPosition);
        if(this.partners.length == 0) throw new Error(1);

      } catch (e) {
        if(e.message == 1) {
          if(this.range < 150) {
            this.msgError = 'Nenhum ponto de retirada próximo a sua localização foi encontrado. Tente aumentar a distância de busca ou tente outra maneira de encontrar um ponto de retirada.';
          } else {
            this.msgError = 'Nenhum ponto de retirada próximo encontrado para sua localização atual.'
          }
        } else {
          this.msgError = 'Não foi possível encontrar sua localização atual. Por favor verifique se sua localização está ativada, ou tente outra maneira de encontrar o ponto de retirada mais próximo.';
        }
        this.showMsgEror = true;
        return;
      } finally {
        this.loading = false;
      }
    },

    getCurrentLocalization() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(response => {
          resolve({
            latitude: response.coords.latitude,
            longitude: response.coords.longitude
          });
        },
        error => {
          reject(error);
        });
      });
    },

    getLatLngGoogle(address) {
      return new Promise((resolve, reject) => {
        try {
          new google.maps.Geocoder().geocode({ address }, async response => {
            // buscando cep pelo maps
            if(response.length > 0) {
              return resolve({
                latitude: response[0].geometry.location.lat(),
                longitude: response[0].geometry.location.lng()
              })
            } else { // buscando cep pelo serviço da mm
              const res = await AddressService.getLatLng(cep);
              return resolve({
                latitude: res.latitude,
                longitude: res.longitude
              });
            }
          });

        } catch (e) {

          reject(e);
        }
      });
    },

    async getPartnersByPosition(position) {

      const request = {
        latitude: position.latitude,
        longitude: position.longitude,
        range: this.range
      }

      this.partners = await Account.getPartnersByPosition(request);
      this.partnersFiltered = this.partners;
    },

    async getPartnersByCity(address, position) {

      const { city, state } = address;

      this.partners = await Account.getPartnersByCity(city.split('-')[0].trim(), state.length == 2 ? state : '', position);
      this.partnersFiltered = this.partners;
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/withdrawal-points.js